/**
 * Error Codes
 * Standardized error code constants for client/server error handling.
 */

export const ERROR_CODES = {
    // Client-side
    INVALID_REQUEST: "INVALID_REQUEST",
    VALIDATION_ERROR: "VALIDATION_ERROR",
    NETWORK_ERROR: "NETWORK_ERROR",
    TIMEOUT_ERROR: "TIMEOUT_ERROR",

    // Authentication
    INVALID_EMAIL: "INVALID_EMAIL",
    INVALID_CREDENTIALS: "INVALID_CREDENTIALS",
    ACCOUNT_LOCKED: "ACCOUNT_LOCKED",
    ACCOUNT_DISABLED: "ACCOUNT_DISABLED",
    // SECURITY: REMOVED USER_NOT_FOUND to prevent User Enumeration.
    // The API should return generic "If email exists, we sent a link" messages.

    // OTP / Verification
    INVALID_OTP: "INVALID_OTP",
    OTP_EXPIRED: "OTP_EXPIRED",
    OTP_MAX_ATTEMPTS: "OTP_MAX_ATTEMPTS",

    // MFA
    TOTP_INVALID: "TOTP_INVALID",
    INVALID_MFA_CODE: "INVALID_MFA_CODE",
    INVALID_BACKUP_CODE: "INVALID_BACKUP_CODE",
    MFA_REQUIRED: "MFA_REQUIRED", // Added
    WEBAUTHN_NOT_SUPPORTED: "WEBAUTHN_NOT_SUPPORTED",
    WEBAUTHN_FAILED: "WEBAUTHN_FAILED",
    WEBAUTHN_VERIFICATION_FAILED: "WEBAUTHN_VERIFICATION_FAILED",

    // Session
    TOKEN_EXPIRED: "TOKEN_EXPIRED",
    TOKEN_INVALID: "TOKEN_INVALID",
    SESSION_EXPIRED: "SESSION_EXPIRED",
    SSO_REQUIRED: "SSO_REQUIRED",

    // Password Reset / Recovery (ADDED)
    PASSWORD_RESET_TOKEN_INVALID: "PASSWORD_RESET_TOKEN_INVALID",
    PASSWORD_RESET_TOKEN_EXPIRED: "PASSWORD_RESET_TOKEN_EXPIRED",
    RECOVERY_TOKEN_INVALID: "RECOVERY_TOKEN_INVALID",
    RECOVERY_TOKEN_EXPIRED: "RECOVERY_TOKEN_EXPIRED",
    RECOVERY_REQUEST_NOT_FOUND: "RECOVERY_REQUEST_NOT_FOUND",
    RECOVERY_REQUEST_DENIED: "RECOVERY_REQUEST_DENIED",
    PASSWORD_TOO_WEAK: "PASSWORD_TOO_WEAK",
    PASSWORD_RECENTLY_USED: "PASSWORD_RECENTLY_USED",

    // Advanced Recovery Errors
    INVALID_RECOVERY_SESSION: "INVALID_RECOVERY_SESSION",
    CHANNEL_MISMATCH: "CHANNEL_MISMATCH",
    AUTHORITY_REQUIRED: "AUTHORITY_REQUIRED",
    INVALID_VERIFICATION_TOKEN: "INVALID_VERIFICATION_TOKEN",

    // Server
    SERVER_ERROR: "SERVER_ERROR",
    SERVICE_UNAVAILABLE: "SERVICE_UNAVAILABLE",
    RATE_LIMITED: "RATE_LIMITED",
    RATE_LIMIT_EXCEEDED: "RATE_LIMIT_EXCEEDED",
} as const;

export type ErrorCode = (typeof ERROR_CODES)[keyof typeof ERROR_CODES];
